import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Modal } from 'react-bootstrap';
import MypageReturn from '../molecules/MypageReturn';
import Popup from '../molecules/Popup';
import { status_code_list } from '../Const';
interface Props {
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  is_guarantor_agreement: boolean;
  is_implement_online_identification: boolean;
  clickAgree: () => Promise<any>;
  clickDisagree: () => Promise<any>;
}

// KWANKGM04290_近代化資金 確認(連帯債務者等)のフッター部
const FooterContentInquiryModernizationFundsMainDetailsInquiry: React.FC<Props> = ({
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  is_guarantor_agreement,
  is_implement_online_identification,
  clickAgree,
  clickDisagree,
}) => {
  const history = useHistory();
  const [modal_disagree, setModalDisagree] = useState(false);
  const [modal_error, setModalError] = useState(false);

  // 「同意する」ボタンクリック時のアクション
  const handleClickAgree = async () => {
    const valid_result = await clickAgree();
    // バリデーションエラーがあるか判定
    if (valid_result) {
      // エラーが無ければ確認画面へ遷移
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/agree`);
    }
  };

  // 不同意確認ポップアップの「同意しない」ボタンクリック時のアクション
  const handleClickDisagree = async () => {
    const result = await clickDisagree();
    if (result) {
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/disagree`);
    }
  };

  // 同意する・同意しないボタンの表示
  const outputAgreeButton = () => {
    if (status_code !== status_code_list.borrowing_application_check) {
      return null;
    }
    return (
      <Row className="mt-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-danger">
          <div className="text-left sp-button-center">
            <a
              className={`btn btn-xl btn-danger sp-btn-height ${(!is_guarantor_agreement ||
                is_implement_online_identification) &&
                'disabled-bg'}`}
              onClick={handleClickOpenDisagree}
            >
              同意しない
            </a>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a
              className={`btn btn-xl btn-main-color sp-btn-height ml-auto ${(!is_guarantor_agreement ||
                is_implement_online_identification) &&
                'disabled-bg'}`}
              onClick={handleClickAgree}
            >
              同意する
            </a>
          </div>
        </Col>
      </Row>
    );
  };

  // 「同意しない」ボタンクリック時のアクション
  const handleClickOpenDisagree = () => {
    setModalDisagree(true);
  };

  return (
    <>
      {outputAgreeButton()}
      <MypageReturn is_staff={is_staff} />
      <Popup
        title="不同意の確認"
        text="借入申込の内容に不同意を表明します。よろしいですか？"
        first_button={{
          label: '同意しない',
          variant: 'danger',
          handleClick: () => {
            handleClickDisagree();
            setModalDisagree(false);
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => setModalDisagree(false),
        }}
        toggleClose={() => setModalDisagree(false)}
        toggleShow={modal_disagree}
      />
      {/* エラーダイアログ */}
      <Modal
        show={modal_error}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>システムエラーが発生しました。</Modal.Body>
        <Modal.Footer>
          <a className="btn btn-outline-success" onClick={() => setModalError(false)}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default memo(FooterContentInquiryModernizationFundsMainDetailsInquiry);
